import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { Book, UserPlus } from "lucide-react";
import { toast } from "sonner";

const RegisterPage = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", businessName: "" });
  const [loading, setLoading] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Haslo musi miec minimum 6 znakow");
      return;
    }
    setLoading(true);
    try {
      await register(form.email, form.password, form.name, form.businessName);
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Rejestracja nie powiodla sie");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 text-2xl font-bold text-indigo-600 mb-2">
            <Book className="w-8 h-8" />
            <span>StoryBook</span>
          </div>
          <p className="text-slate-500">Stworz konto fotografa</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Imie i nazwisko</label>
            <input
              type="text"
              value={form.name}
              onChange={set("name")}
              required
              className="w-full border border-slate-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              placeholder="Jan Kowalski"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Nazwa firmy (opcjonalne)</label>
            <input
              type="text"
              value={form.businessName}
              onChange={set("businessName")}
              className="w-full border border-slate-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              placeholder="JK Foto"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
            <input
              type="email"
              value={form.email}
              onChange={set("email")}
              required
              className="w-full border border-slate-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              placeholder="jan@example.com"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Haslo</label>
            <input
              type="password"
              value={form.password}
              onChange={set("password")}
              required
              minLength={6}
              className="w-full border border-slate-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              placeholder="Minimum 6 znakow"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2.5 rounded-lg font-medium flex items-center justify-center gap-2 transition-colors disabled:opacity-50"
          >
            <UserPlus className="w-4 h-4" />
            {loading ? "Rejestracja..." : "Zarejestruj sie"}
          </button>
          <p className="text-center text-sm text-slate-500">
            Masz juz konto?{" "}
            <Link to="/login" className="text-indigo-600 hover:underline font-medium">
              Zaloguj sie
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default RegisterPage;
